module.exports = __webpack_public_path__ + "static/media/graph-1.f061ec81.png";